import {openFullscreenGallery} from "../../../../default/global/js/fullscreengallery";

export function initVideos(videoWrapper = document.querySelectorAll('.js-video')) {
    videoWrapper.forEach((video) => new VideoController(video));
}

class VideoController {
    videoWrapper;
    videoElement;
    playToggleElement;
    audioToggleElement;
    fullscreenGallerySelector=".js-video-gallery";
    constructor(videoWrapper) {
        this.videoWrapper = videoWrapper;
        this.videoElement = videoWrapper.querySelector('video');
        this.playToggleElement = videoWrapper.querySelector('.js-toggle-video');
        this.audioToggleElement = videoWrapper.querySelector('.js-toggle-audio');
        this.fullscreenToggleElement = videoWrapper.querySelector('.js-toggle-fullscreen');
        this.sortSourceTypesBasedOnDevice();
        this.initEventListeners();
        this.initInitialState();
    }
    /**
     * Change order so that desktop users get mp4 and mobil users webm
     */
    sortSourceTypesBasedOnDevice(){
        const sources = Array.from(this.videoElement.querySelectorAll('source'));
        const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        if (!isMobile) {
            sources.forEach(src => {
                if (src.type === 'video/mp4') {
                    this.videoElement.insertBefore(src, this.videoElement.firstChild);
                }
            });
            this.videoElement.load();
        }
    }
    initEventListeners() {
        this.playToggleElement?.addEventListener('click', () => {
            if (this.videoElement.paused) {
                this.videoElement.play();
            } else {
                this.videoElement.pause();
            }
        });
        this.audioToggleElement?.addEventListener('click', () => {
            this.videoElement.muted = !this.videoElement.muted;

        });
        this.videoElement?.addEventListener('volumechange', () => {
            if (this.videoElement.muted || this.videoElement.volume === 0) {
                this.updateOnMuteVideo();
            } else {
                this.updateOnUnmuteVideo();
            }
        });

        this.videoElement?.addEventListener('play', () => {
            this.updateOnPlayVideo();
        });

        this.videoElement?.addEventListener('pause', () => {
            this.updateOnStopVideo();
        });
        this.videoElement?.addEventListener('ended', () => {
            this.updateOnStopVideo();
        });
        this.fullscreenToggleElement?.addEventListener('click',()=>{
           openFullscreenGallery(this.fullscreenToggleElement,this.fullscreenGallerySelector);
        });
    }

    initInitialState() {
        if (!this.videoElement.paused && !this.videoElement.ended && this.videoElement.readyState > 2) {
            this.updateOnPlayVideo();
        } else {
            this.updateOnStopVideo();
        }
        this.videoElement.muted=true;
    }

    updateOnPlayVideo() {
        this.playToggleElement.classList.add('is-playing');
        this.playToggleElement.setAttribute("aria-label", GLOBALS.tc.pauseVideo);
        this.videoWrapper.classList.add('is-playing');
    }

    updateOnStopVideo() {
        this.playToggleElement.classList.remove('is-playing');
        this.playToggleElement.setAttribute("aria-label", GLOBALS.tc.playVideo);
        this.videoWrapper.classList.remove('is-playing');
    }

    updateOnMuteVideo() {
        this.audioToggleElement.classList.add('is-muted');
        this.audioToggleElement.setAttribute("aria-label", GLOBALS.tc.unmuteVideo);
        this.videoWrapper.classList.add('is-muted');
    }

    updateOnUnmuteVideo() {
        this.audioToggleElement.classList.remove('is-muted');
        this.audioToggleElement.setAttribute("aria-label", GLOBALS.tc.muteVideo);
        this.videoWrapper.classList.remove('is-muted');
    }
}